import {
  BoundRadioGroupField,
  Button,
  FormLines,
  ModalBody,
  ModalFooter,
  ModalHeader,
  useModal,
} from "@homebound/beam";
import { InternalEstimateType } from "src/generated/graphqlTypes";
import { BidPackageDetailPageDocument } from "src/routes/bids/BidPackageDetailPage.generated";
import { BiddersTab_BidderFragment } from "src/routes/bids/components/BiddersTab.generated";
import { internalEstimateTypeOptions } from "src/routes/bids/plan-based-bid-package/utils";
import { useSaveBidContractMutation } from "src/routes/developments/procurement/DevelopmentContractPage.generated";
import { ObjectConfig, useFormState } from "src/utils/formState";

type EditInternalEstimateTypeModalProps = { bidContract: NonNullable<BiddersTab_BidderFragment["bidContract"]> };

export function EditInternalEstimateTypeModal({ bidContract }: EditInternalEstimateTypeModalProps) {
  const { closeModal } = useModal();
  const [saveBidContract] = useSaveBidContractMutation({ refetchQueries: [BidPackageDetailPageDocument] });
  const formState = useFormState({
    config: formConfig,
    init: {
      onlyOnce: true,
      input: { internalEstimateType: bidContract.internalEstimateType?.code ?? InternalEstimateType.Provisional },
    },
  });

  async function handleSave() {
    await saveBidContract({
      variables: { input: { id: bidContract.id, internalEstimateType: formState.internalEstimateType.value } },
    });
    closeModal();
  }

  return (
    <div data-testid="editInternalEstimateTypeModal">
      <ModalHeader>Change Estimate Type</ModalHeader>
      <ModalBody>
        <FormLines>
          <BoundRadioGroupField
            label="Estimate Type"
            options={internalEstimateTypeOptions}
            field={formState.internalEstimateType}
          />
        </FormLines>
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="tertiary" onClick={closeModal} />
        <Button label="Save" onClick={handleSave} />
      </ModalFooter>
    </div>
  );
}

type FormValues = { internalEstimateType?: InternalEstimateType | null };

const formConfig: ObjectConfig<FormValues> = { internalEstimateType: { type: "value" } };
